// interpolate a string and fill in the parameters
// ex:
// input: interpolate("My name is: {firstName} {lastName}.", { firstName: "Enzo", lastName: "Eghermanne"});
// output: "My name is Enzo Eghermanne."
export const interpolate = (template, parameters) =>
	Object.entries(parameters).reduce((acc, [key, val]) => (acc = acc.replace(new RegExp(`{${key}}`, 'g'), val)), template);
